import { createAsyncThunk } from '@reduxjs/toolkit'
import railsApiService from 'services/api/rails-api-service'
import { Consultation, DoctorCommunicationChannel } from 'types'

interface CreateConsultationParams {
  _requestVersion?: number
  consultation: {
    nutrition_offer?: boolean
    nutrition_offer_consultation_id?: number
    appointment_at?: string
    communication_channel?: DoctorCommunicationChannel
    consultation_type?: string
    doctor_id?: number
    patient_attributes: {
      first_name: string
      last_name: string
      ssn: string
      phone_number: string
      terms_of_service: boolean
      cgu_accepted: boolean
      cpf_number: string
      complete_name: string
      email: string
    }
    survey_id?: number
    survey_submission?: any
    atm_hash?: string
    is_free?: boolean
    is_smart_fit?: boolean
    is_ironberg?: boolean
    is_medleve?: boolean
    /** Set to true for live (waiting-line) consultations — backend forces visio/weight_loss/medleve */
    is_live?: boolean
  }
}

export const createConsultation = createAsyncThunk(
  'create-consultation',
  async (params: CreateConsultationParams, { rejectWithValue }) => {
    try {
      const { _requestVersion, ...consultationParams } = params
      const { data } = await railsApiService.apiInstance.post<Consultation>('/api/v1/consultations', consultationParams)

      return { ...data, _requestVersion }
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
